import React, { useEffect, useState } from "react";
import { subscribe } from "./api";
import { Alert, Button, Col, Form, Modal, Row, Spinner } from "react-bootstrap";
import { getLocale } from "./i18nRefs.jsx";

const filteredTn = (tn) => {
  return tn.replace(/\D/g, "");
};

// http://en.wikipedia.org/wiki/North_American_Numbering_Plan
const isNANPTn = (tn) => {
  return /[2-9]\d{9}/.test(filteredTn(tn));
};

export const SubscribeNumberModal = ({ i18n, show, onClose }) => {
  let [phonenumber, setPhoneNumber] = useState("");
  let [name, setName] = useState("");
  let [submitting, setSubmitting] = useState(false);
  let [submitted, setSubmitted] = useState(false);
  let [error, setError] = useState("");

  const onSubmit = async (e) => {
    e.preventDefault();

    if (!isNANPTn(phonenumber)) {
      setError(i18n.PLS_ENTER_VALID_10NUM);
      return false;
    } else {
      setError("");
    }

    setSubmitting(true);
    console.log(getLocale());
    const subscriber = { subscriber: phonenumber, name: name, lang: getLocale() };
    await subscribe(subscriber, "sms");
    // await new Promise(resolve => setTimeout(() => resolve(), 3000))
    setSubmitting(false);
    setPhoneNumber("");
    setSubmitted(true);
    return false;
  };

  const validatePhoneNumber = (tn) => {
    if (!isNANPTn(tn)) {
      setError(i18n.PLS_ENTER_VALID_10NUM);
    } else {
      setError("");
    }
  };


  useEffect(() => {
    setName("");
    setPhoneNumber("");
    setSubmitting(false);
    setSubmitted(false);
  }, [show]);

  return (
    <Modal show={show} onHide={onClose} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>{i18n.SUBSCRIBE_TX_NOTIFS}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={onSubmit}>
          {!submitted && (
            <div>
              <Form.Group>
                <Form.Label>
                  {i18n.NAME}
                </Form.Label>
                <Form.Control
                  type="name"
                  placeholder={i18n.ENTER_NAME}
                  value={name}
                  onChange={(e) => {
                    setName(e.target.value);
                    setError("");
                  }}
                  disabled={submitting}
                />

                <br />

                <Form.Label>
                  {i18n.PHONE_NUMBER}
                </Form.Label>
                <Form.Control
                  type="tel"
                  placeholder={i18n.PLS_ENTR_TO_RECV_TXT}
                  title={i18n.PHONE_NUMBER}
                  value={phonenumber}
                  onChange={(e) => {
                    setPhoneNumber(e.target.value);
                    setError("");
                  }}
                  onBlur={(e) => validatePhoneNumber(e.target.value)}
                  disabled={submitting}
                />
                <br />
                <Form.Text>{i18n.PERSONAL_INFORMATION_DISCLOSURE}</Form.Text>
              </Form.Group>
            </div>
          )}

          {error !== "" && (
            <Alert variant={"danger"}>
              <p>{error}</p>
            </Alert>
          )}

          {submitted && <div className={"text-center"}>{i18n.SUBSCRIBED}</div>}

          <Row style={{ marginTop: "20px" }}>
            <Col>
              {!submitted && !submitting && (
                <Button variant="outline-danger" onClick={onClose}>
                  {i18n.CANCEL}
                </Button>
              )}
            </Col>
            <Col style={{ textAlign: "right" }}>
              {!submitted && (
                <Button variant="primary" type={"submit"}>
                  {!submitting ? (
                    i18n.SUBSCRIBE
                  ) : (
                    <Spinner
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                    />
                  )}
                </Button>
              )}
            </Col>
          </Row>
        </Form>
      </Modal.Body>
    </Modal>
  );
};
